import { render } from "./SquadReportModal.vue?vue&type=template&id=83cbc498"
import script from "./SquadReportModal.vue?vue&type=script&lang=js"
export * from "./SquadReportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__